import { Link } from 'react-router-dom';

// Image
import aboutImg from '../../assets/images/about/about.jpg';

const About = () => {

    return (
        <div className="about__area about__area_one p-relative pt---100 pb---100">
            <div className="container">                        
                <div className="row">
                    <div className="col-lg-6">
                        <div className="about__image">
                            <img src={aboutImg} alt="About" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about__content">
                            <h2 className="about__title wow animate__fadeInUp" data-wow-duration="0.3s">Welcome to <br/> <em>Terranova University</em></h2>
                            <p className="about__paragraph wow animate__fadeInUp" data-wow-duration="0.5s">Welcome to Terranova University, where limitless possibilities await. Browse our diverse educational programs designed to shape your future.</p>
                            <p className="about__paragraph2 wow animate__fadeInUp" data-wow-duration="0.7s"> <Link to="#"> Explore Degrees  </Link></p>
                            <p className="wow animate__fadeInUp" data-wow-duration="0.6s">Terranova University is committed to fostering academic excellence, innovation, and global citizenship through a rigorous, inclusive learning environment. Our mission is to empower students with the knowledge, skills, and values needed to lead meaningful, impactful lives in an ever-evolving world.</p>
                            <ul className="wow animate__fadeInUp" data-wow-duration="0.9s">
                                <li><Link to="#" className="more-about"> About Terranova <svg xmlns="https://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></Link></li>
                                <li className="last-li">
                                    <em>Contact Us</em>
                                    <Link to="mailto:demo@demo.com">demo@demo.com</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;